// Landing page copy, keyed by locale. Only "en" is active; add "fr" here once fully translated and tested.
export const DEFAULT_LOCALE = "en";
export const ACTIVE_LOCALES = ["en"];

const en = {
  hero: {
    eyebrow: "FREE 5-DAY SIDEBIZZ CHALLENGE",
    title: "Living in Mauritius? What Would an Extra Rs 10,000 a Month Mean for You?",
    sub1: "Already working but wish you could earn some extra money?",
    sub2: "Discover 3 side business ideas that match your budget, skills and available time. Then follow 5 simple steps to explore how you could get started.",
    points: ["No need to quit your current job.", "No business experience required.", "Simple exercises you can complete on your phone."],
    cta: "FIND MY 3 FREE BUSINESS IDEAS", ctaLoggedIn: "CONTINUE MY CHALLENGE",
    note: "100% Free • No Credit Card Required • Just a Few Minutes a Day",
  },
  product: {
    title: "Find Side Business Ideas That Actually Fit Your Life",
    text: "Tell us how much time you have, your starting budget and what interests you. Sidebizz will help you explore 3 ideas that suit your situation.",
    example: "EXAMPLE", question: "How much can you spend to get started?",
    options: ["Rs 0", "Less than Rs 5,000", "Rs 5,000 to Rs 14,999", "Rs 15,000 or more"],
    recsTitle: "Your 3 ideas (example)", startFrom: "Estimated starting budget:",
    cta: "DISCOVER MY FREE IDEAS",
  },
  problem: {
    title: "Your Salary Pays the Bills. But What If You Could Earn Something Extra?",
    lines: ["Between groceries, transport, bills and family expenses, putting money aside isn't always easy.", "You might want to earn more, but finding a second job isn't always practical.",
      "A small side activity could be worth exploring — something that fits your schedule and budget.", "The difficult part is knowing where to start."],
    highlight: "You don't have to quit your job. Start by finding an idea you can realistically test.",
  },
  examples: {
    title: "3 Side Business Ideas You Could Explore in Mauritius",
    cards: [["Virtual Administrative Assistance", "Help small businesses organize documents, manage files and handle simple administrative tasks remotely."],
      ["Custom Invitations & Greeting Cards", "Create personalized invitations for weddings, birthdays and special events."],
      ["Made-to-Order Meals & Cakes", "Prepare food or baked products based on customer orders, while considering costs and applicable requirements."]],
    more: "And these are just 3 examples from the {n} business ideas available on Sidebizz.",
    cta: "FIND IDEAS THAT MATCH ME",
  },
  days: {
    title: "In Just 5 Days, Go From \"I Don't Know What to Do\" to a Clearer Business Idea",
    sub: "One short lesson. One practical exercise. One step forward each day.",
    items: [["Discover Your Ideas", "Answer a few questions and discover 3 side business ideas suited to your profile."],
      ["Choose Your Idea", "Compare your options and select one activity you would like to explore further."],
      ["Create Your First Offer", "Decide what you could offer, who your customers might be and what price you could test."],
      ["Test Customer Interest", "Learn how to ask the right questions and collect genuine feedback from potential customers."],
      ["Plan Your Next Steps", "Get your personal Idea Brief with your selected idea, what you still need to check and your next 3 actions."]],
    day: "DAY", langNote: "Video lessons are currently narrated in French, with simple exercises.",
    cta: "START MY FREE CHALLENGE",
  },
  trust: {
    title: "You Don't Need to Be a Business Expert to Get Started",
    cards: [["Already Working Full-Time?", "Explore activities you could test during evenings or weekends."],
      ["Limited Starting Budget?", "Find ideas that better match your available resources before spending money."],
      ["No Business Idea Yet?", "Sidebizz helps you explore possibilities and prepare your first steps."]],
  },
  free: {
    title: "Why Are We Offering This Challenge for Free?",
    paras: ["Before spending money on a side business, it makes sense to find an idea that suits you and start checking whether customers might be interested.",
      "That's why Sidebizz lets you take these first steps for free.", "If you want to explore more ideas or create a more detailed launch plan, we also offer paid options.",
      "But you can complete all 5 days without making a purchase."],
    cta: "GET STARTED FOR FREE",
  },
  guide: {
    title: "Want More Ideas and Instant Access to All 5 Days?", sub: "Explore {n} Business Ideas for Mauritius",
    text: "The free challenge helps you discover 3 ideas matched to your profile. With the Sidebizz Business Ideas Guide, you can explore all {n} ideas and unlock the entire 5-day challenge immediately.",
    benefits: ["{n} business ideas to explore.", "Options for different budgets and schedules.", "Immediate access to all 5 challenge days.", "All challenge exercises available at your own pace."],
    once: "one-time payment", cta: "EXPLORE {n} IDEAS — {price}", free: "CONTINUE FOR FREE",
    note: "Access is activated once our team has confirmed your payment.",
  },
  builder: {
    title: "Found an Idea? Here's How to Take It Further.",
    text: "Business Builder helps you prepare your offer, estimate costs and organize your next steps with a personalized launch plan.",
    price: "Business Builder — {price}/year", cta: "EXPLORE BUSINESS BUILDER",
  },
  faqTitle: "Frequently Asked Questions",
  faq: [["Is the challenge really free?", "Yes. You can complete the five lessons and exercises for free, with one new day unlocking every 24 hours."],
    ["Do I need to quit my job?", "No. The challenge helps you explore activities that may fit around your existing schedule."],
    ["Can I really earn Rs 10,000 or more per month?", "Rs 10,000 is an example of an income goal, not guaranteed earnings. Your results would depend on the activity, customer demand, time invested and expenses."],
    ["What if I have no business experience?", "The challenge is designed for beginners. You'll follow simple steps and exercises."],
    ["How much time does it take?", "Plan around 10–15 minutes a day for the lessons and initial exercises. Some activities, like speaking with potential customers, may take longer."],
    ["Why should I buy the {price} guide?", "The guide gives you access to {n} business ideas and unlocks all five challenge days immediately."],
    ["What's the difference between the guide and Business Builder?", "The guide helps you explore and choose ideas. Business Builder takes you further with detailed planning tools and a personalized launch plan."]],
  final: {
    title: "Your Next Source of Income Could Start With Finding the Right Idea",
    sub: "Answer a few questions, explore your options and take your first step with Sidebizz.",
    cta: "FIND MY 3 FREE BUSINESS IDEAS", note: "Free • No Credit Card • Start From Your Phone",
  },
  sticky: "FIND MY 3 FREE IDEAS",
  signupSub: "Then start Day 1 right away.",
};

export const challengeLanding = { en };

export const fill = (s, vars) => s.replace(/\{(\w+)\}/g, (_, k) => (vars[k] ?? `{${k}}`));
export const getChallengeCopy = (locale = DEFAULT_LOCALE) => challengeLanding[ACTIVE_LOCALES.includes(locale) ? locale : DEFAULT_LOCALE];
